import { Empty as AEmpty } from 'antd';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import React from 'react';

export default function() {
  return <AEmpty image={AEmpty.PRESENTED_IMAGE_SIMPLE} description={<FormattedMessage {...messages.noData} />} />;
}
